import Vue from 'vue';
import Vuex from 'vuex';
import template from './templateStore';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    template
  },
  strict: debug
});
